<span>{{  date ? ( date | dateFormat | async) : '' }}</span>